import React from "react";
import GHGNav from "./GHGNav";
import CountBanner from "../../CommonComponents/CountBanner";
import Button from "../../Components/Button";

const GHGHero = () => {
  const handleSmoothScroll = (event, targetId) => {
    event.preventDefault();
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <head>
        <title>Professional Training & Certification | TVE International Academy</title>
        <meta name="description" content="Join TVE International Academy for globally recognized professional training courses. Get certified in ISO 9001, ISO 14001, ISO 45001, and more." />
        <meta name="keywords" content="TVE Training, ISO Certification, ISO 9001, ISO 14001, ISO 45001, CQI IRCA, Exemplar Global, Health and Safety Training" />
      </head>
      <div loading="lazy" className="relative h-screen bg-ghgbg bg-no-repeat w-full bg-cover">
        <GHGNav />
        <div className="w-full h-full flex items-center">
          <div
            className="ml-100 flex-col
              max-md:justify-center 
              max-md:text-center               
              max-md:m-14"
          >
            <h1 className="text-H leading-snug text-white font-semibold capitalize">
              Greenhouse Gas Accounting (GHG) <br/> 
              <span className="text-H">ISO 14064:2018
                </span>
            </h1>
            {/* <p
              className="w-500 mt-4 text-white text-P font-light
                   max-md:w-full"
            >
              TVE International Academy is a globally recognized training body, delivering professional courses including CQI and IRCA Certified Trainings, Exemplar Global Approved Trainings, and Health & Safety Trainings. Join our community of 15,000+ students and enhance your skills in our exclusive TVE Community Portal.
            </p> */}
            <div
              className="mt-4 flex gap-6 
                   max-md:justify-center                   
                   max-md:items-center
                   max-sm:flex-col"
            >
              <a
                href="https://forms.gle/T2obbU7ZhkDPNGj79"
               target="_blank"
              >
                <Button text="Register Course" />
              </a>
              <a
                href="https://drive.google.com/file/d/13BWeqq4pYWBnje9-1fjb_RDZeBbl1gDU/view?usp=sharing"
                target="_blank"
              >
                <Button text="View Details" />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="-mt-10 relative z-10">
       
      </div> */}
    </>
  );
};

export default GHGHero;
